import { render, staticRenderFns } from "./SingleVersionField.vue?vue&type=template&id=341cac86&"
import script from "./SingleVersionField.vue?vue&type=script&lang=ts&"
export * from "./SingleVersionField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports